import 'jquery';
import 'jquery-ui-bundle';
import 'popper.js';
import 'bootstrap';
import '@fortawesome/fontawesome-free';
import 'hammerjs';

// import Swiper bundle with all modules installed
import Swiper from 'swiper/swiper-bundle';
window.Swiper = Swiper;
